export default "__VITE_ASSET__7b516a29__"